export const initialState = {
    loading: true,
    activity: {},
    alert: {
        severity: '', //error,warning,info,success
        message: ''
    },
    timeTaken: 0,
    tabs: {
        content: true,
        assessment: false,
    },
    multipleChoiceContents: [],
    openEndedAnswers : [],
    isSecretCode: false,
    secretCode: '',
    customDialog: {
        open: false,
        message: '',
        severity: 'success',
        isLoading: false
    },
    isTeamActivity:false
};

export const activityReducer = (state = initialState, action) => {
    switch (action.type) {
        case 'SET_LOADING':
            return { ...state, loading: action.loading };
        case 'SET_ACTIVITY':
            return { ...state, activity: action.activity };
        case 'SET_ALERT':
            return { ...state, alert: action.alert };
        case 'SET_TIMETAKEN':
            return { ...state, timeTaken: action.timeTaken };
        case 'SET_TABS':
            return { ...state, tabs: action.tabs };
        case 'SET_MULTIPLECHOICE_CONTENTS':
            return { ...state, multipleChoiceContents: action.multipleChoiceContents };
        case 'SET_OPENENDED_ANSWERS':
                return {...state, openEndedAnswers: action.openEndedAnswers};
        case 'SET_IS_SECRETCODE':
            return { ...state, isSecretCode: action.isSecretCode };
        case 'SET_SECRET_CODE':
            return { ...state, secretCode: action.secretCode };
        case 'SET_CUSTOMDIALOG':
            return { ...state, customDialog: action.customDialog };
        case 'SET_IS_TEAMACTIVITY':
            return {...state, isTeamActivity:action.isTeamActivity};
        default:
            return state;
    }
}
